import React, { useState } from "react";
import { useDropzone } from "react-dropzone";

import { Guid } from "guid-typescript";

import { Text } from "@plex/react-components";

import { commonMessages } from "infrastructure/localization";
import { useLocalizedValues } from "ui/hooks";

import { ProgressBar } from "../progress-bar";

import styles from "./Upload.module.scss";

export interface IUploadProps {
  id?: string;
  uploadingProcessing?: boolean;
  onFilesAttached: (file: File[]) => void;
  accept?: string[];
  progress?: number;
}

export const Upload: React.FC<IUploadProps> = ({ uploadingProcessing, onFilesAttached, progress = 0, accept, id = `upload-button-${Guid.raw()}` }) => {
  const localizedValues = useLocalizedValues(() => ({
    selectFileText: commonMessages.info("selectFileText"),
    uploadFileCaption: commonMessages.info("attachFileAreaCaption"),
    noFileSelectedText: commonMessages.info("noFileSelectedText")
  }));

  const [selectedFileName, setSelectedFileName] = useState(localizedValues.noFileSelectedText);

  const { getRootProps, open, getInputProps } = useDropzone({
    onDropAccepted: (filesList: File[]) => {
      /* istanbul ignore next */
      if (filesList.length) {
        setSelectedFileName(filesList[0].name);
        onFilesAttached(filesList);
      }
    },
    accept: accept
  });

  return (
    <div className={styles.base}>
      {uploadingProcessing && <div className={styles.backdrop}></div>}
      <div className={styles.progressBar}>{uploadingProcessing && <ProgressBar currentValue={progress} />}</div>
      <span className={styles.uploadButton}>
        <input type="button" id={id} value={localizedValues.selectFileText} onClick={open} />
        <Text labelFor={id} text={selectedFileName} />
      </span>
      <div {...getRootProps({ className: styles.dropzone })}>
        <input {...getInputProps()} />
        <p>{localizedValues.uploadFileCaption}</p>
      </div>
    </div>
  );
};
